<template>
    <div class="z-20 relative w-full" data-cy="container_topbar_back_image">
        <div class="h-6 bg-a-blue-002850"></div>
        <div>
            <img class="pt-2" :src="icBackUrl()" data-cy="btn_topbar_back" @click="onClickBack()" />
        </div>
    </div>

</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "TopBarBack",
    mixins: [LocaleMixin],
    data: function() {
        return {};
    },
    methods: {
        onClickBack: function(){
            this.$emit('onClickBack');
        },
        icBackUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/img-back.png`;
        },
    },
}
</script>
<!-- <style lang="scss" scoped>
.bg-topbar{
    background-image: url('../../../assets/bg/bg-topbar.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
}
</style> -->
